var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Aside extends Component {
    constructor() {
        super('Aside', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-open-aside').on('click', (event, button) => {
                event.preventDefault();
                $('aside').addClass('opened');
                $('#aside-backdrop').addClass('active');
            });
            $('body').on('click', '.btn-close-aside', (event, button) => {
                event.preventDefault();
                $('aside').removeClass('opened');
                $('#aside-backdrop').removeClass('active');
                $('#form-request-quote').removeClass('opened');
                $('#btn-request-quote').removeClass('d-none');
                $('#list .spacer').addClass('offset-lg-22 offset-xl-26');
            });
            let asidePosition = parseInt($('#menu-right').css('top'));
            $(window).on('scroll', (event) => {
                if ($(window).width() < 991)
                    return;
                if (window.pageYOffset > asidePosition - 8) {
                    $('#menu-right').removeClass('position-absolute').addClass('position-fixed');
                }
                else {
                    $('#menu-right').addClass('position-absolute').removeClass('position-fixed');
                }
            });
            this.success();
        });
    }
}
